import type { AboTable_table$key } from '@generated/AboTable_table.graphql';
import type { IAboTableHeaderRelayProps } from './lib/aboHeader';
import type { OtherDocumentsGraphQLProps } from './lib/otherDocuments';

export interface IDocumentsSubscribed {
  all: boolean;
  kid: boolean;
  factsheet: boolean;
  publications: boolean;
  rb: boolean;
  hjb: boolean;
  taxtreat: boolean;
  fpp: boolean;
  info: boolean;
  prospect: boolean;
  __dataID__?: any;
}

export interface IDocumentsSubscribedState {
  all: 0 | 1 | 2;
  kid: boolean;
  factsheet: boolean;
  publications: boolean;
  rb: boolean;
  hjb: boolean;
  taxtreat: boolean;
  fpp: boolean;
  info: boolean;
  prospect: boolean;
}

export interface AboTrancheRowType {
  id: string;
  fundsname?: string;
  isin?: string;
  category?: string;
  currency?: string;
  distribution?: string;
  salesadmission: Array<string>;
  documents: IDocumentsSubscribed;
}

export interface AboTrancheRowExtendedType extends AboTrancheRowType {
  all: boolean;
  kid: boolean;
  factsheet: boolean;
  other: any;
  otherall: 0 | 1 | 2;
  subscribed: 'true' | 'false';
}

export interface IAboTableRelayProps {
  id?: string;
  entries?: AboTrancheRowType[];
  tableheader: Array<IAboTableHeaderRelayProps>;
  documentheaders: IDocumentsSubscribed;
  documentlabels?: OtherDocumentsGraphQLProps;
  livefilter?: any;
  languagepreference?: any;
  detailfilter?: any;
  traits?: any;
  subscriptionfilter?: any;
  filterbuttontext?: string;
  filterbuttontextexpanded?: string;
  noResultsMessage: string;
}

export interface AboTablePropsType {
  table: AboTable_table$key;
  salesAdmission: string;
}

export enum SortOrder {
  ASC = -1,
  DESC = 1,
}

export interface SortObjectType {
  col: string;
  order: SortOrder;
}
